export default "__VITE_ASSET__TH$blStc__"